import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { get_PlayerCard1h4x7zc5wjxwf as get_PlayerCard } from './PlayerCard.mjs';
import {
  setDefaultKeyykye56baz645 as setDefaultKey,
  addChildspxcpid5g99g as addChild,
} from '../../../../../../../kotlin-react-core/react/ChildrenBuilder.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function PlayerCard(_this__u8e3s4, player, className, onClick, size, deselected, tilt, key) {
  className = className === VOID ? null : className;
  onClick = onClick === VOID ? null : onClick;
  size = size === VOID ? null : size;
  deselected = deselected === VOID ? null : deselected;
  tilt = tilt === VOID ? null : tilt;
  key = key === VOID ? null : key;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var component = get_PlayerCard();
  setDefaultKey(_this__u8e3s4, '@rdk/23_4');
  // Inline function 'react.ChildrenBuilder.invoke' call
  var block = ($this$component) => {
    $this$component.player = player;
    var tmp0_safe_receiver = className;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      $this$component.className = tmp0_safe_receiver;
    }
    var tmp1_safe_receiver = onClick;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      $this$component.onClick = tmp1_safe_receiver;
    }
    var tmp2_safe_receiver = size;
    if (tmp2_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      $this$component.size = tmp2_safe_receiver;
    }
    var tmp3_safe_receiver = deselected;
    if (tmp3_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      $this$component.deselected = tmp3_safe_receiver;
    }
    var tmp4_safe_receiver = tilt;
    if (tmp4_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      $this$component.tilt = tmp4_safe_receiver;
    }
    var tmp5_safe_receiver = key;
    if (tmp5_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      $this$component.key = tmp5_safe_receiver;
    }
    return Unit_instance;
  };
  addChild(_this__u8e3s4, component, block);
}
//region block: exports
export {
  PlayerCard as PlayerCard292pm37x5pt2b,
};
//endregion

//# sourceMappingURL=PlayerCardKt.mjs.map
